import { render, staticRenderFns } from "./PurchaseOrderList.vue?vue&type=template&id=0175eeca"
import script from "./PurchaseOrderList.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports